import React, { useEffect, useRef, useState } from "react";
import { gl_start } from "./webgl";

function Scene() {
this.vertexShader = `#version 300 es
in vec3 aPos;
out vec3 vPos;

void main() {
    vPos = aPos;
    gl_Position = vec4(aPos, 1.0);
}
`;

this.fragmentShader = `#version 300 es
precision mediump float;
out vec4 fragColor;

void main() {
    fragColor = vec4(0.0, 0.0, 1.0, 1.0);
}
`;
}

export default () => {
    const canvasRef = useRef(null);
    const [code, setCode] = useState("");

    useEffect( () => {
        const scene = new Scene();
        // gl_start will initialize WebGL and start the draw loop; it sets a global `gl`
        // and doesn't reliably return it synchronously, so we don't expect a value here.
        gl_start(canvasRef.current, scene);

        // setCode(`${scene.vertexShader}\n${scene.fragmentShader}`);
        // setCode( Scene.toString() );
        setCode(`Vertex Shader\n${scene.vertexShader}\nFragment Shader\n${scene.fragmentShader}`);
    }, []);
    
    return (
        <div style = { { position: "relative", display: "flex", justifyContent: "center", marginBottom: 20, gap : "16px" } }>
            <canvas ref = {canvasRef} width={400} height={400} />
            <pre>{ code }</pre>
        </div>
    );
}